/**
 * Returns the difference between two arrays.
 * @param source The source array.
 * @param target The target array.
 * @returns An array containing the elements that are in the source but not in the target.
 */
export function getDifference<T = any>(source: Array<T>, target: Array<T>) {
  const sourceSet = new Set(source);
  const targetSet = new Set(target);

  return Array.from(new Set([...sourceSet].filter((x) => !targetSet.has(x))));
}
